import { useQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';
import { mapToDomain } from '@infuse/e-connector/charging-station/domain';
import { getChargingStation } from '@infuse/api/e-connector/charging-station';

export const useChargingStation = () => {
  const fetchChargingStationId = ref<string | undefined>(undefined);

  const query = useQuery({
    queryKey: ['charging-stations', fetchChargingStationId],
    queryFn: async () => {
      const response = await getChargingStation({ id: fetchChargingStationId.value as string });
      return mapToDomain(response);
    },
    enabled: computed(() => !!fetchChargingStationId.value)
  });

  return {
    ...query,
    fetchChargingStationId,
    chargingStation: query.data
  };
};
